// 개발 모드에서만 로그를 출력하는 유틸리티
// 빌드 시 상수로 치환되어 런타임 오버헤드 없음
const isDevelopment = process.env.NODE_ENV === 'development';

// 프로덕션에서 로그 완전 비활성화
const noop = () => {};

export const logger = {
  log: isDevelopment ? (...args: any[]) => console.log(...args) : noop,
  error: isDevelopment ? (...args: any[]) => console.error(...args) : noop,
  warn: isDevelopment ? (...args: any[]) => console.warn(...args) : noop,
  info: isDevelopment ? (...args: any[]) => console.info(...args) : noop,
  debug: isDevelopment ? (...args: any[]) => console.debug(...args) : noop,
  group: isDevelopment ? (...args: any[]) => console.group(...args) : noop,
  groupEnd: isDevelopment ? () => console.groupEnd() : noop
};

// 기존 console.log를 대체하는 함수
export const devLog = isDevelopment ? (...args: any[]) => console.log(...args) : noop;
export const menuLog = isDevelopment ? (...args: any[]) => console.log(...args) : noop;
export const timerLog = isDevelopment ? (...args: any[]) => console.log(...args) : noop;
export const sseLog = isDevelopment ? (...args: any[]) => console.log(...args) : noop;
export const orderLog = isDevelopment ? (...args: any[]) => console.log(...args) : noop;
export const analyticsLog = isDevelopment ? (...args: any[]) => console.log(...args) : noop;